/**
 * Created by andrey on 31.07.2023
 */

const FogBalloonView = cc.Node.extend({
    ctor: function (baloon) {
        this._super();

        this.balloon = baloon;

        const styles = cleverapps.styles.FogBalloonView;
        this.setBalloonPosition();
        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize(styles);

        if (!cleverapps.config.editorMode) {
            cleverapps.UI.applyHover(this, {
                filter: function () {
                    return Map2dLocation.currentLocation && Map2dLocation.currentLocation.tutorial && !Map2dLocation.currentLocation.tutorial.isActive() || !cleverapps.tutorial.isActive();
                }
            });
            cleverapps.UI.onClick(this, () => {
                baloon.block.showBuyWindow();
            }, {
                filter: function () {
                    return Map2dLocation.currentLocation && Map2dLocation.currentLocation.tutorial && !Map2dLocation.currentLocation.tutorial.isActive() || !cleverapps.tutorial.isActive();
                }
            });
        }

        const animation = this.animation = new cleverapps.Spine(bundles.merge.jsons.fog_balloon_json);
        const skins = animation.listSkins();
        if (skins.length > 0) {
            animation.setSkin(`${baloon.block.options.id % skins.length}`);
        }

        animation.setAlignment(styles.animation);
        this.addChild(this.animation);

        baloon.onHide = this.createListener(this.hide.bind(this));
        baloon.onShow = this.createListener(this.show.bind(this));

        if (baloon.shown) {
            this.show(true);
        } else {
            this.hide(true);
        }
    },

    hide: function (silent) {
        if (silent) {
            this.visible = false;
        } else {
            this.runAction(new cc.Sequence(
                new cc.ScaleTo(0.15, 0),
                new cc.CallFunc(() => {
                    this.visible = false;
                    this.setScale(1);
                })
            ));
        }
    },

    show: function (silent) {
        this.visible = true;

        if (silent) {
            this.animation.setAnimation(0, "idle", true);
        } else {
            this.animation.setAnimationAndIdleAfter("open", "idle");
        }
    },

    setBalloonPosition: function () {
        const x = this.balloon.tile.x;
        const y = this.balloon.tile.y;
        const mapView = Map2d.currentMap.getMapView();

        mapView.alignViewInGrid(x, y, this);
        this.setLocalZOrder(mapView.getFogViewLocalZOrder(x, y));
    }
});

cleverapps.styles.FogBalloonView = {
    height: 270,
    width: 150,

    animation: {
        x: { align: "center", dx: 20 },
        y: { align: "center", dy: -50 }
    }
};